import { css } from "@emotion/css";

import { blue, grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createTypographyStyles = ({
  typography,
  spacing,
  palette,
}: Theme) => {
  return {
    root: css({
      lineHeight: "normal",
    }),
    pageHeading: css({
      fontSize: typography.pxToRem(22),
      fontWeight: typography.fontWeight.bold,
      color: palette.default.text,
      margin: spacing([1, 0]),
    }),
    heading: css({
      fontSize: typography.pxToRem(22),
      margin: spacing([1, 0]),
      fontWeight: typography.fontWeight.semiBold,
      color: palette.default.text,
    }),
    headingLarge: css({
      fontSize: typography.pxToRem(30),
      color: blue[800],
      fontWeight: typography.fontWeight.bold,
    }),
    subheading: css({
      fontSize: typography.pxToRem(16),
      color: grey[600],
      fontWeight: typography.fontWeight.bold,
    }),
    contentLarge: css({
      fontSize: typography.pxToRem(16),
      color: grey[900],
      fontWeight: typography.fontWeight.medium,
    }),
    contentMedium: css({
      fontSize: typography.pxToRem(14),
      fontWeight: typography.fontWeight.normal,
      color: palette.default.text,
    }),
    contentSmall: css({
      fontSize: typography.pxToRem(12),
      color: grey[600],
      fontWeight: typography.fontWeight.medium,
    }),
  };
};
